// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"824":"9119db5939172b9f","4718":"a15955cf87dc07e4","5653":"8f93a43f53546067","5935":"01c61b737987b0e0","6481":"3dbda6681e0d75c6","8202":"3eda88c6a04abb64"}[chunkId] + ".css";
};